<template lang="">
  <h3 class="project">Project 👎</h3>
  <ul class="project-info">
    <li>
      <a href="https://github.com/olatunde1998/AltSchool-Vue-Exam3">Github</a>
    </li>
    <li>
      <a href="https://altschool-vue-exam-3.vercel.app/">Hosting/Live link</a>
    </li>
  </ul>
</template>
<script setup></script>
<style>
.project-info {
  padding-left: 10px;
  color: rgb(81, 71, 71);
  font-weight: 200;
}
.project {
  color: white;
}
a {
  text-decoration: none;
  color: rgb(81, 71, 71);
  cursor: pointer;
}
</style>
